// @flow
import AppContainer from './AppContainer';

export default AppContainer;
